// extracted by mini-css-extract-plugin
export default {"TemperatureInput":"Temperature_TemperatureInput__u3wQ9","Comma":"Temperature_Comma__VdqKb"};